const center: 'center' = 'center';

export const inputStyles = {
  fontFamily: 'monospace',
  borderRadius: '8px',
  border: 'none',
  marginRight: '15px',
  fontSize: '40px',
  fontWeight: 500,
  color: '#162952',
  backgroundColor: '#F0F0F0',
  lineHeight: '49px',
  textAlign: center,
  padding: 0,
};

export const inputStyleInvalid = {
  fontFamily: 'monospace',
  borderRadius: '8px',
  border: 'none',
  marginRight: '15px',
  fontSize: '40px',
  fontWeight: 500,
  color: '#B94A48',
  backgroundColor: '#F2DEDE',
  lineHeight: '49px',
  textAlign: center,
  padding: 0,
};
